var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_3061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 0H7.96875C3.56773 0 0 3.56773 0 7.96875V26.0312C0 30.4323 3.56773 34 7.96875 34H26.0312C30.4323 34 34 30.4323 34 26.0312V7.96875C34 3.56773 30.4323 0 26.0312 0Z",
    fill: "url(#paint0_radial_59_3061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 0H7.96875C3.56773 0 0 3.56773 0 7.96875V26.0312C0 30.4323 3.56773 34 7.96875 34H26.0312C30.4323 34 34 30.4323 34 26.0312V7.96875C34 3.56773 30.4323 0 26.0312 0Z",
    fill: "url(#paint1_radial_59_3061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0009 7C14.2851 7 13.9442 7.0119 12.8776 7.0604C11.813 7.1092 11.0863 7.2777 10.4505 7.52499C9.7927 7.78039 9.2348 8.12209 8.679 8.67808C8.1227 9.23398 7.781 9.79187 7.5248 10.4494C7.2768 11.0854 7.1081 11.8124 7.0602 12.8764C7.0125 13.9431 7 14.2841 7 17C7 19.7159 7.012 20.0557 7.0604 21.1223C7.1094 22.1868 7.2779 22.9135 7.525 23.5493C7.7806 24.2071 8.1223 24.765 8.6783 25.3208C9.234 25.8771 9.7919 26.2196 10.4492 26.475C11.0855 26.7223 11.8123 26.8908 12.8767 26.9396C13.9434 26.9881 14.284 27 16.9997 27C19.7158 27 20.0556 26.9881 21.1222 26.9396C22.1868 26.8908 22.9143 26.7223 23.5506 26.475C24.2081 26.2196 24.7652 25.8771 25.3208 25.3208C25.8771 24.765 26.2187 24.2071 26.475 23.5496C26.7208 22.9135 26.8896 22.1866 26.9396 21.1225C26.9875 20.0559 27 19.7159 27 17C27 14.2841 26.9875 13.9433 26.9396 12.8766C26.8896 11.8121 26.7208 11.0855 26.475 10.4497C26.2187 9.79187 25.8771 9.23398 25.3208 8.67808C24.7646 8.12189 24.2083 7.78019 23.55 7.52509C22.9125 7.2777 22.1854 7.1091 21.1208 7.0604C20.0541 7.0119 19.7145 7 16.9978 7H17.0009ZM16.1038 8.80208C16.3701 8.80168 16.6672 8.80208 17.0009 8.80208C19.671 8.80208 19.9874 8.81168 21.0418 8.85958C22.0168 8.90418 22.546 9.06708 22.8985 9.20398C23.3652 9.38518 23.6979 9.60187 24.0477 9.95197C24.3977 10.302 24.6143 10.6353 24.796 11.102C24.9329 11.454 25.096 11.9832 25.1404 12.9581C25.1883 14.0123 25.1987 14.3289 25.1987 16.9977C25.1987 19.6665 25.1883 19.9832 25.1404 21.0373C25.0958 22.0122 24.9329 22.5414 24.796 22.8935C24.6148 23.3602 24.3977 23.6925 24.0477 24.0423C23.6977 24.3923 23.3654 24.6089 22.8985 24.7902C22.5464 24.9277 22.0168 25.0902 21.0418 25.1348C19.9876 25.1827 19.671 25.1931 17.0009 25.1931C14.3307 25.1931 14.0142 25.1827 12.9601 25.1348C11.9851 25.0898 11.4559 24.9269 11.1031 24.79C10.6365 24.6087 10.3031 24.3921 9.9531 24.0421C9.6031 23.6921 9.3865 23.3596 9.2048 22.8927C9.0679 22.5406 8.9048 22.0114 8.8604 21.0365C8.8125 19.9823 8.8029 19.6657 8.8029 16.9952C8.8029 14.3248 8.8125 14.0098 8.8604 12.9556C8.905 11.9807 9.0679 11.4515 9.2048 11.099C9.3861 10.6323 9.6031 10.299 9.9532 9.94897C10.3032 9.59897 10.6365 9.38228 11.1032 9.20068C11.4557 9.06318 11.9851 8.90068 12.9601 8.85588C13.8826 8.81418 14.2401 8.80168 16.1038 8.79958V8.80208ZM22.3389 10.4625C21.6764 10.4625 21.1389 10.9995 21.1389 11.6621C21.1389 12.3245 21.6764 12.862 22.3389 12.862C23.0014 12.862 23.5389 12.3245 23.5389 11.6621C23.5389 10.9996 23.0014 10.4625 22.3389 10.4625ZM17.0009 11.8646C14.1649 11.8646 11.8655 14.1639 11.8655 17C11.8655 19.8361 14.1649 22.1343 17.0009 22.1343C19.837 22.1343 22.1356 19.8361 22.1356 17C22.1356 14.164 19.837 11.8646 17.0009 11.8646ZM17.0009 13.6666C18.8418 13.6666 20.3343 15.1589 20.3343 17C20.3343 18.8409 18.8418 20.3334 17.0009 20.3334C15.1599 20.3334 13.6676 18.8409 13.6676 17C13.6676 15.1589 15.1599 13.6666 17.0009 13.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_59_3061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.03125 36.6187) rotate(-90) scale(33.6965 31.3404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_59_3061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.69513 2.4492) rotate(78.681) scale(15.0625 62.0882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_3061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.4cfdf7afb8bb96c5bd27067e8fb1490b.svg";
export { ForwardRef as ReactComponent };